import React from 'react';
import styled, { css } from 'styled-components';
import palette from '../../lib/styles/palette';
import Select from 'react-select';
import { inputNumberAutoComma } from '../../lib/commonFunc/commonFunc';

const SelectItemViewBlock = styled.div`
padding: 20px 20px 20px 20px;
`;

const SelectItemButton = styled.button`
flex:1;
height: 60px;
border-radius: 4px;
margin: 10px 10px 10px 10px;
justify-content: center;
align-items: center;
font-weight: bold;
cursor: pointer;

${(props) =>
        props.select ?
            css`
        background: ${palette.webCyan[5]};
        border: 0px solid ${palette.webCyan[5]};
    `
            :
            css`
        border: 1px solid ${palette.webCyan[5]};
        background: ${palette.white};
    `
    }
`;


const CartButton = styled.button`
width: 200px;
height: 60px;
border-radius: 4px;
margin: 20px 20px 20px 20px;
justify-content: center;
align-items: center;
font-weight: bold;
cursor: pointer;
border: 1px solid ${palette.webCyan[5]};
background: ${palette.webCyan[5]};
`;


const CartDeleteButton = styled.button`
width: 150px;
height: 30px;
border-radius: 4px;
margin: 20px 20px 20px 20px;
justify-content: center;
align-items: center;
font-weight: bold;
cursor: pointer;
border: 1px solid ${palette.webCyan[5]};
`;

const SubInfoInput = styled.input`
    width: 200px;
    padding: 10px 10px;
    border: 1px solid ${palette.webGray[16]};
    border-radius: .2rem;
    margin-top:10px;

    &:focus {
        outline: none;
    }
`;

const SubTextInfoInput = styled.input`
    width: 400px;
    padding: 10px 10px;
    border: 1px solid ${palette.webGray[16]};
    border-radius: .2rem;
    margin-top:10px;

    &:focus {
        outline: none;
    }
`;

const TermsButton = styled.button`
width: 80px;
height: 30px;
border-radius: 4px;
margin: 20px 20px 20px 20px;
justify-content: center;
align-items: center;
font-weight: bold;
color: #fff;
cursor: pointer;
background: ${palette.skyBlue1};
border: 0px;
`;

const CommitButton = styled.button`
width: 300px;
height: 100px;
border-radius: 4px;
margin: 20px 20px 20px 20px;
justify-content: center;
align-items: center;
font-weight: bold;
font-size: 1.6rem;
color: #fff;
cursor: pointer;
background: #1A73E9;
border: 0px;
`;


const ImageBox = styled.div`
    width:100%;
    height:100%;
    display:flex;
  justify-content: center;
  align-items: center;
  position: relative;
  & img {
  }
`;
const SubImageBox = styled.div`
    width:150px;
    height:150px;
    background: #f00;
    position: absolute;
    
    bottom:0;
    right:0;
  & img {
  }
`;

const StyledInput = styled.input`
  font-size: 1rem;
  border: 1px solid ${palette.gray3};
  padding: 0.5rem;
  outline: none;
  width: 300px;
  margin-left: 1rem;
  margin-right: 1rem;
  &:focus {
    color: ${palette.blue1};
  }
  & + & {
    margin-top: 1rem;
  }
`;

const TableA = styled.table`
@media (min-width: 640px) {
    table {
      display: inline-table !important;
    }

    thead tr:not(:first-child) {
      display: none;
    }
  }

  td:not(:last-child) {
    border-bottom: 0;
  }

  th:not(:last-child) {
    border-bottom: 2px solid rgba(0, 0, 0, .1);
  }`

const SelectItemView = ({
    selectItemInfos,
    selectItemOptionInfos,
    onSelectItemIndex,
    selectItemIndex,
    onSelectOption,
    selectOptionData,
    colorOption,
    decorationOption,
    fontOption,
    imageOption,
    pendantOption,
    sizeOption,
    optionPrice,
    selectItem,

    cartList,
    cartSelectList,
    onAddCart,
    onDeleteCart,
    onClearCart,
    onAddCartSelectList,

    onChangeUserName,
    userName,
    onChangeUserPhone,
    userPhone,
    onChangeUserEmail,
    userEmail,
    onChangeFrontText,
    frontText,
    onChangeBackText,
    backText,
    termsCheck,
    onChangeTermsCheck,
    setTermsView,
    termsView,

    onCommit,
    addprice,
    viewType,
    tableType,
    selectItemInfosSelectList,
}) => {
    let isCart = false;
    if (selectOptionData) {
        isCart = ((selectOptionData.color != 0) && (selectOptionData.pendant != 0) && (selectOptionData.size != 0))
        console.log(`colorimage ${selectOptionData.colorImage}`)
    }

    let totalPrice = 0;
    if (cartList && cartList.length > 0) {
        for (let i = 0; i < cartList.length; i++) {
            totalPrice += cartList[i].totalPrice
        }
    }

    const isSelectColor = colorOption.filter((option) => {
        return option.value === selectOptionData.color;
    })

    const bgColor = viewType == 'mydingo' ? '#005DAB' : '#E96061'
    let terminfo = `\n[쿠폰펫 개인정보처리방침] \n\n쿠폰펫 (이하 “회사”라 함)는 정보통신망이용촉진 및 정보보호등에 관한법률, 개인정보보호법 등 개인정보와 관련된 법령상의 규정들을 준수하고 있으며, 개인정보처리방침을 제정하여 이용자의 권익보호에 최선을 다하고 있습니다. 회사는 개인정보처리방침을 통하여 이용자의 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 회사가 어떠한 조치를 취하는지 알려드립니다. 회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.\n\n1. 수집하는 개인정보의 항목 및 수집방법\n가. 수집하는 개인정보의 항목\n회사는 회원가입(Google 간편로그인, 네이버 간편로그인, Meta 간편로그인, Kakao 간편로그인 포함), 비회원 구매, 상담, 불량이용의 방지 등을 위해 아래와 같은 개인정보를 수집하고 있습니다. \n- 필수항목 : \n• 회원가입 및 물품구매\n이름, 아이디, 비밀번호, 생일, 성별, 이메일, IP Address\n• 동물등록 업무대행\n반려동물 정보(이름, 사진, 견종, 성별, 강아지 이력, 중성화 수술 여부, 출생일, 입양일, 몸무게, 병력 등)\n관련 근거 : 동물보호법 제12조(등록대상동물의 등록 등) 제1항, 동물보호법 시행규칙 제8조(등록대상동물의 등록사항 및 방법 등) 제1항\n\n- 선택항목 : 개인맞춤 서비스를 제공하기 위하여 회사가 필요로 하는 정보 \n\n나. 수집방법\n회사는 이용자들이 회원서비스를 이용하기 위해 회원으로 가입하실 때 서비스 제공을 위한 필수적인 정보들을 온라인 상에서 입력 받고 있습니다. 또한 서비스 내에서의 설문조사나 이벤트 행사 시 통계분석이나 경품 제공 등을 위해 선별적으로 개인정보 입력을 요청할 수 있습니다. 그러나, 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않으며 부득이하게 수집해야 할 경우 이용자들의 사전동의를 반드시 구할 것입니다. \n\n2. 개인정보의 수집 및 이용목적\n가. 신규 서비스의 개발\n이용자들이 제공한 개인정보를 바탕으로 보다 더 유용한 서비스를 개발할 수 있습니다. 회사는 신규 서비스 개발이나 컨텐츠의 확충 시에 기존 이용자들이 회사에 제공한 개인정보를 바탕으로 개발해야 할 서비스의 우선 순위를 보다 더 효율적으로 정하고, 회사는 이용자들이 필요로 할 컨텐츠를 합리적으로 선택하여 제공할 수 있습니다.\n\n나. 회원관리\n회원제 서비스 이용에 따른 본인확인, 개인 및 반려동물 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 만14세 미만 아동 개인정보 수집 시 법정 대리인 동의여부 확인, 불만처리 등 민원처리, 고지사항 전달\n\n다. 마케팅 및 광고에 활용\n신규 서비스 개발과 이벤트 행사에 따른 정보 전달 및 맞춤 서비스 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계 \n\n3. 개인정보의 보유 및 이용기간\n회사는 이용자의 개인정보를 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.\n\n가. 회사의 내부방침에 의한 정보보유 사유\n- 부정이용기록 : 부정이용 방지\n- 보존기간 : 부정이용일로부터 1년\n\n나. 관련법령에 의한 정보보유 사유\n- 계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)\n- 대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)\n- 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률)\n- 방문(로그)에 관한 기록 : 3개월(통신비밀보호법)\n\n4. 개인정보의 파기 절차 및 방법\n가. 이용자의 개인정보는 개인정보의 수집 및 이용목적이 달성되면 지체 없이 아래와 같은 방법으로 파기합니다.\n\n- 회원가입 정보 : 회원탈퇴를 요청한 시점으로 30일 후(회원의 요구사항 처리, 포인트 소멸 일시 보류 등의 목적으로 30일간의 유예기간을 두고 파기합니다.\n- 배송정보 : 물품 또는 서비스가 인도되거나 제공된 때\n- 설문조사, 이벤트 등의 목적을 위하여 수집한 경우 : 당해 설문조사, 이벤트 등을 종료한 때\n- 본인확인정보 : 본인임을 확인 한 때\n단, 상법 등 관련법령의 규정 및 내부 방침에 의하여 다음과 같이 거래 관련 관리 의무 관계의 확인 등을 이유로 일정기간 보유하여야 할 필요가 있을 경우에는 일정기간 보유합니다.\n- 계약 또는 청약철회 등에 관한 기록 : 5년\n- 대금결제 및 재화 등의 공급에 관한 기록 : 5년\n- 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년\n- 접속에 관한 기록 : 6개월\n- 접근통제 내역에 관한 기록 : 5년\n\n나. 개인정보 파기방법은 아래와 같습니다.\n- 종이에 출력된 개인정보 : 분쇄기로 분쇄하거나 소각\n- 전자적 파일형태로 저장된 개인정보 : 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제\n\n5. 개인정보의 제3자 제공 \n가. ' 쿠폰펫 '는 이용자들의 개인정보를 '개인정보의 수집, 이용' 에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이 동 범위를 초과하여 이용하거나 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.\n- 이용자들이 사전에 공개 또는 제3자 제공에 동의한 경우\n- 법령의 규정에 의거하거나, 수사, 조사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관 및 감독당국의 요구가 있는 경우\n- 요금 정산을 위하여 필요한 경우\n\n나. 그 밖에 개인정보 제3자 제공이 필요한 경우에는 이용자의 동의를 얻는 등 적법한 절차를 통하여 제3자에게 개인정보를 제공할 수 있습니다. ' 쿠폰펫 '는 이용자들의 거래 이행을 위하여 필요한 경우 이용자의 동의를 얻는 등 적법한 절차를 통하여 아래와 같이 개인정보를 제공할 수 있습니다.\n\n다. 이용자는 개인정보의 제3자 제공에 대하여 동의를 하지 않을 수 있고, 언제든지 제3자 제공 동의를 철회할 수 있습니다. 동의를 거부하시는 경우에도 회원가입서비스는 이용하실 수 있으나, 제 3자 제공에 기반한 관련 서비스의 이용/제공이 제한될 수 있습니다.\n\n- 이용 목적 : 관계사(제휴사)별 서비스 및 이벤트 정보 제공 (SMS/전자우편/DM/TM 등) 제휴행사 및 서비스 홍보를 위한 마케팅\n- 제공하는 개인정보항목 : 고유식별정보를 제외한 수집/이용에 동의하신 개인정보\n- 보유 및 이용기간 : 회원탈퇴를 요청한 시점으로 30일 후 또는 개인정보 제3자 제공 동의 철회 전까지\n\n6. 개인정보의 처리위탁\n회사는 서비스의 원활한 제공을 위해 개인정보를 위탁처리하고 있으며, 관련 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.\n\n현재 회사의 개인정보처리수탁자와 그 업무의 내용은 다음과 같습니다.\n\n- 택배사 (우체국택배 등): 성명, 연락처, 주소\n- Amazon Web Service 쿠폰펫 시스템 운영 및 데이터 보관 \n- (주)카카오페이, 삼성페이, SSG페이, 네이버페이, 페이코 : 전자결제 수단 제공\n- 이니시스 : 상품 구매에 필요한 신용카드, 현금결제 등의 결제정보 전송\n\n7. 이용자 및 법정대리인의 권리와 그 행사방법\n가. 이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며 가입해지(동의철회)를 요청할 수도 있습니다.\n\n나. 이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는 로그인 후 마이페이지에서 ‘개인정보변경’(또는 ‘회원정보수정’ 등)을, 가입해지(동의철회)를 위해서는 "회원탈퇴"를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은 개인정보보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.\n\n다. 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다. \n\n라. 회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 "3. 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.\n\n8. 쿠키(cookie)의 운영에 관한 사항\n회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’ 등을 운용합니다. 쿠키란 회사의 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 아주 작은 텍스트 파일로서 이용자의 컴퓨터 하드디스크에 저장됩니다. \n\n가. 쿠키 등 사용 목적\n이용자의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 맞춤 서비스 제공\n\n나. 쿠키의 설치/운영\n이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. \n\n다. 쿠키 설정 거부 방법\n쿠키 설정을 거부하는 방법으로는 이용자가 사용하시는 웹 브라우저의 옵션을 택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. 단, 이용자께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.\n\n설정방법 예(인터넷 익스플로어의 경우) : 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보\n\n9. 개인정보보호를 위한 기술적/관리적 대책 \n가. 회사는 이용자의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조, 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.\n- 이용자의 개인정보는 암호화 되어 보호되고 있습니다. 그러나 이용자의 개인정보를 회사가 암호화시켜 보호하고 있음에도 불구하고 공공장소에서의 인터넷사용 등의 과정에서 의도하지 않게 분실하거나 타인에게 도난 또는 유출될 가능성이 있습니다. 그러므로 이용자는 개인정보를 타인에게 유출시키거나 대여, 제공 등 공개하여서는 아니 되며, 피싱 등 사회공학적 방법에 의한 개인정보 무단 수집으로부터 자신의 개인정보를 책임 있게 관리하여야 합니다. 이러한 개인정보의 분실, 도난 유출, 피싱, 공개에 대해서 회사는 어떠한 책임도 지지 않습니다. \n- 이용자의 개인정보는 기본적으로 비밀번호에 의해 보호되며, 파일 및 전송 데이터를 암호화하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다.\n- 회사는 항상 새로운 정보를 자동으로 Update하는 백신을 이용하여 컴퓨터 바이러스에 의한 피해를 방지하기 위해 24시간 근무요원이 상주하면서 보호조치를 취하고 있습니다. 만일, 바이러스 침투시 자동으로 바이러스 침투 Alarm을 근무자에게 보냄과 동시에 자동 치료하도록 되어 있습니다.\n- 회사는 암호알고리즘을 이용하여 네트워크상의 개인정보를 안전하게 전송할 수 있는 보안장치(SSL 또는 SET)를 채택하고 있습니다.\n- 회사는 해킹 등 회사 정보통신망 침입에 의해 이용자의 개인정보가 유출되는 것을 방지하기 위해 외부로부터의 침입탐지 및 침입차단 시스템을 24시간 가동하고 있습니다.\n\n나. 회사는 이용자의 개인정보보호의 중요성을 인식하고 있으며 이용자의 개인정보보호를 위해 개인정보처리직원을 최소한으로 제한하는 등 다음과 같은 관리적 조치를 취하고 있습니다.\n- 개인정보를 처리하는 직원을 대상으로 새로운 보안 기술 습득 및 개인정보보호의무 등에 관해 정기적인 사내교육 및 외부 위탁교육을 실시하고 있습니다. \n- 회사는 모든 입사자에게 보안서약서를 제출케 함으로 사람에 의한 정보유출을 사전에 방지하고 개인정보처리방침에 대한 이행사항 및 직원의 준수여부를 감시하고 위반내용이 확인되는 경우 이를 시정 또는 개선하고 기타 필요한 조치를 취하기 위한 내부절차를 마련하고 있습니다. 개인정보 관련 처리자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며 입사/퇴사 후 개인정보 사고에 대한 책임을 명확화하고 있습니다. \n- 개인정보와 일반 데이터를 혼합하여 보관하지 않고 별도의 서버를 통해 분리하여 보관하고 있습니다. \n- 전산실 및 자료 보관실 등을 특별 보호구역으로 설정하여 출입을 통제하고 있습니다. \n- 회사는 이용자 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 이용자 개개인이 본인의 개인정보를 보호하기 위해서 자신의 아이디(ID) 와 비밀번호를 적절하게 관리하고 이에 대한 책임을 져야 합니다.\n\n10. 개인정보보호책임자\n' 쿠폰펫 '는 이용자가 당사의 서비스를 안전하게 이용할 수 있도록 최선을 다하고 있습니다. 이용자는 당사의 서비스 이용과 관련한 모든 민원을 신고하실 수 있으며, 당사는 이용자의 신고사항에 대해 신속하고 성실하게 답변해드리고 있습니다.\n\n개인정보보호책임자 성명 : 최현미\n이메일　: pets-look@naver.com\n전화번호　: 070-4337-4269\n\n기타 개인정보침해에 대한 신고 또는 상담이 필요하신 경우에는 아래 기관으로 문의하시기 바랍니다.\n\n개인정보분쟁조정위원회 전화 : 1833-6972 ( http://www.kopico.go.kr)\n개인정보침해신고센터전화 :(국번없이)118 ( http://privacy.kisa.or.kr)\n대검찰청 첨단범죄수사센터전화 : 02-3480-2000 (http://www.spo.go.kr)\n경찰청 사이버안전국전화 : (국번없이)182 (http://cyberbureau.police.go.kr)\n\n11. 고지의 의무 \n가. 본 개인정보처리방침을 포함한 기타 개인정보보호에 대한 상세한 내용은 서비스 홈페이지 첫 화면에 공개함으로써 이용자가 언제나 용이하게 보실 수 있도록 조치하고 있습니다.\n나. 법령 정책 또는 보안기술의 변경에 따라 중요한 내용의 추가 삭제 및 수정이 있을 시에는 변경되는 개인정보처리방침을 시행하기 전에 서비스 홈페이지를 통해 변경이유 및 내용 등에 대하여 공지하도록 하겠습니다.\n다. 본 개인정보처리방침의 내용은 수시로 변경될 수 있으므로 서비스홈페이지를 방문하실 때 마다 이를 확인하시기 바랍니다. \n\n12. 맟춤제작 상품의 취소,반품,교환\n가. 구매자의 요청에 따라 개별 맞춤 제작되는 상품의 경우 판매자의 의해 취소/반품/교환이 제한될 수 있습니다.\n나. 판매자의 설정에 의해 취소/반품/교환에 관한 제한이 설정되어도 소비자 보호에 관한 법률 제 17조에 위배될 경우, 구매자는 보호받을 수 있습니다.\n다. 취소/반품/교환 제한 사유에 해당되지 않을 경우 일반 상품과 동일하게 취급하여 청약철회가 가능합니다. \n본 방침은 : 2023년 1월 3일부터 시행됩니다.`;
    if (viewType == 'mydingo') {
        terminfo = `\n[마이딩고 개인정보처리방침] \n\n마이딩고 (이하 “회사”라 함)는 정보통신망이용촉진 및 정보보호등에 관한법률, 개인정보보호법 등 개인정보와 관련된 법령상의 규정들을 준수하고 있으며, 개인정보처리방침을 제정하여 이용자의 권익보호에 최선을 다하고 있습니다. 회사는 개인정보처리방침을 통하여 이용자의 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 회사가 어떠한 조치를 취하는지 알려드립니다. 회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.\n\n1. 수집하는 개인정보의 항목 및 수집방법\n가. 수집하는 개인정보의 항목\n회사는 회원가입(Google 간편로그인, 네이버 간편로그인, Meta 간편로그인, Kakao 간편로그인 포함), 비회원 구매, 상담, 불량이용의 방지 등을 위해 아래와 같은 개인정보를 수집하고 있습니다. \n- 필수항목 : \n• 회원가입 및 물품구매\n이름, 아이디, 비밀번호, 생일, 성별, 이메일, IP Address\n• 동물등록 업무대행\n반려동물 정보(이름, 사진, 견종, 성별, 강아지 이력, 중성화 수술 여부, 출생일, 입양일, 몸무게, 병력 등)\n관련 근거 : 동물보호법 제12조(등록대상동물의 등록 등) 제1항, 동물보호법 시행규칙 제8조(등록대상동물의 등록사항 및 방법 등) 제1항\n\n- 선택항목 : 개인맞춤 서비스를 제공하기 위하여 회사가 필요로 하는 정보 \n\n나. 수집방법\n회사는 이용자들이 회원서비스를 이용하기 위해 회원으로 가입하실 때 서비스 제공을 위한 필수적인 정보들을 온라인 상에서 입력 받고 있습니다. 또한 서비스 내에서의 설문조사나 이벤트 행사 시 통계분석이나 경품 제공 등을 위해 선별적으로 개인정보 입력을 요청할 수 있습니다. 그러나, 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않으며 부득이하게 수집해야 할 경우 이용자들의 사전동의를 반드시 구할 것입니다. \n\n2. 개인정보의 수집 및 이용목적\n가. 신규 서비스의 개발\n이용자들이 제공한 개인정보를 바탕으로 보다 더 유용한 서비스를 개발할 수 있습니다. 회사는 신규 서비스 개발이나 컨텐츠의 확충 시에 기존 이용자들이 회사에 제공한 개인정보를 바탕으로 개발해야 할 서비스의 우선 순위를 보다 더 효율적으로 정하고, 회사는 이용자들이 필요로 할 컨텐츠를 합리적으로 선택하여 제공할 수 있습니다.\n\n나. 회원관리\n회원제 서비스 이용에 따른 본인확인, 개인 및 반려동물 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 만14세 미만 아동 개인정보 수집 시 법정 대리인 동의여부 확인, 불만처리 등 민원처리, 고지사항 전달\n\n다. 마케팅 및 광고에 활용\n신규 서비스 개발과 이벤트 행사에 따른 정보 전달 및 맞춤 서비스 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계 \n\n3. 개인정보의 보유 및 이용기간\n회사는 이용자의 개인정보를 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.\n\n가. 회사의 내부방침에 의한 정보보유 사유\n- 부정이용기록 : 부정이용 방지\n- 보존기간 : 부정이용일로부터 1년\n\n나. 관련법령에 의한 정보보유 사유\n- 계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)\n- 대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)\n- 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률)\n- 방문(로그)에 관한 기록 : 3개월(통신비밀보호법)\n\n4. 개인정보의 파기 절차 및 방법\n가. 이용자의 개인정보는 개인정보의 수집 및 이용목적이 달성되면 지체 없이 아래와 같은 방법으로 파기합니다.\n\n- 회원가입 정보 : 회원탈퇴를 요청한 시점으로 30일 후(회원의 요구사항 처리, 포인트 소멸 일시 보류 등의 목적으로 30일간의 유예기간을 두고 파기합니다.\n- 배송정보 : 물품 또는 서비스가 인도되거나 제공된 때\n- 설문조사, 이벤트 등의 목적을 위하여 수집한 경우 : 당해 설문조사, 이벤트 등을 종료한 때\n- 본인확인정보 : 본인임을 확인 한 때\n단, 상법 등 관련법령의 규정 및 내부 방침에 의하여 다음과 같이 거래 관련 관리 의무 관계의 확인 등을 이유로 일정기간 보유하여야 할 필요가 있을 경우에는 일정기간 보유합니다.\n- 계약 또는 청약철회 등에 관한 기록 : 5년\n- 대금결제 및 재화 등의 공급에 관한 기록 : 5년\n- 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년\n- 접속에 관한 기록 : 6개월\n- 접근통제 내역에 관한 기록 : 5년\n\n나. 개인정보 파기방법은 아래와 같습니다.\n- 종이에 출력된 개인정보 : 분쇄기로 분쇄하거나 소각\n- 전자적 파일형태로 저장된 개인정보 : 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제\n\n5. 개인정보의 제3자 제공 \n가. ' 마이딩고 '는 이용자들의 개인정보를 '개인정보의 수집, 이용' 에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이 동 범위를 초과하여 이용하거나 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.\n- 이용자들이 사전에 공개 또는 제3자 제공에 동의한 경우\n- 법령의 규정에 의거하거나, 수사, 조사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관 및 감독당국의 요구가 있는 경우\n- 요금 정산을 위하여 필요한 경우\n\n나. 그 밖에 개인정보 제3자 제공이 필요한 경우에는 이용자의 동의를 얻는 등 적법한 절차를 통하여 제3자에게 개인정보를 제공할 수 있습니다. ' 마이딩고 '는 이용자들의 거래 이행을 위하여 필요한 경우 이용자의 동의를 얻는 등 적법한 절차를 통하여 아래와 같이 개인정보를 제공할 수 있습니다.\n\n다. 이용자는 개인정보의 제3자 제공에 대하여 동의를 하지 않을 수 있고, 언제든지 제3자 제공 동의를 철회할 수 있습니다. 동의를 거부하시는 경우에도 회원가입서비스는 이용하실 수 있으나, 제 3자 제공에 기반한 관련 서비스의 이용/제공이 제한될 수 있습니다.\n\n- 이용 목적 : 관계사(제휴사)별 서비스 및 이벤트 정보 제공 (SMS/전자우편/DM/TM 등) 제휴행사 및 서비스 홍보를 위한 마케팅\n- 제공하는 개인정보항목 : 고유식별정보를 제외한 수집/이용에 동의하신 개인정보\n- 보유 및 이용기간 : 회원탈퇴를 요청한 시점으로 30일 후 또는 개인정보 제3자 제공 동의 철회 전까지\n\n6. 개인정보의 처리위탁\n회사는 서비스의 원활한 제공을 위해 개인정보를 위탁처리하고 있으며, 관련 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.\n\n현재 회사의 개인정보처리수탁자와 그 업무의 내용은 다음과 같습니다.\n\n- 택배사 (우체국택배 등): 성명, 연락처, 주소\n- Amazon Web Service 마이딩고 시스템 운영 및 데이터 보관 \n- (주)카카오페이, 삼성페이, SSG페이, 네이버페이, 페이코 : 전자결제 수단 제공\n- 이니시스 : 상품 구매에 필요한 신용카드, 현금결제 등의 결제정보 전송\n\n7. 이용자 및 법정대리인의 권리와 그 행사방법\n가. 이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며 가입해지(동의철회)를 요청할 수도 있습니다.\n\n나. 이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는 로그인 후 마이페이지에서 ‘개인정보변경’(또는 ‘회원정보수정’ 등)을, 가입해지(동의철회)를 위해서는 "회원탈퇴"를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은 개인정보보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.\n\n다. 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다. \n\n라. 회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 "3. 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.\n\n8. 쿠키(cookie)의 운영에 관한 사항\n회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’ 등을 운용합니다. 쿠키란 회사의 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 아주 작은 텍스트 파일로서 이용자의 컴퓨터 하드디스크에 저장됩니다. \n\n가. 쿠키 등 사용 목적\n이용자의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 맞춤 서비스 제공\n\n나. 쿠키의 설치/운영\n이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. \n\n다. 쿠키 설정 거부 방법\n쿠키 설정을 거부하는 방법으로는 이용자가 사용하시는 웹 브라우저의 옵션을 택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. 단, 이용자께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.\n\n설정방법 예(인터넷 익스플로어의 경우) : 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보\n\n9. 개인정보보호를 위한 기술적/관리적 대책 \n가. 회사는 이용자의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조, 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.\n- 이용자의 개인정보는 암호화 되어 보호되고 있습니다. 그러나 이용자의 개인정보를 회사가 암호화시켜 보호하고 있음에도 불구하고 공공장소에서의 인터넷사용 등의 과정에서 의도하지 않게 분실하거나 타인에게 도난 또는 유출될 가능성이 있습니다. 그러므로 이용자는 개인정보를 타인에게 유출시키거나 대여, 제공 등 공개하여서는 아니 되며, 피싱 등 사회공학적 방법에 의한 개인정보 무단 수집으로부터 자신의 개인정보를 책임 있게 관리하여야 합니다. 이러한 개인정보의 분실, 도난 유출, 피싱, 공개에 대해서 회사는 어떠한 책임도 지지 않습니다. \n- 이용자의 개인정보는 기본적으로 비밀번호에 의해 보호되며, 파일 및 전송 데이터를 암호화하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다.\n- 회사는 항상 새로운 정보를 자동으로 Update하는 백신을 이용하여 컴퓨터 바이러스에 의한 피해를 방지하기 위해 24시간 근무요원이 상주하면서 보호조치를 취하고 있습니다. 만일, 바이러스 침투시 자동으로 바이러스 침투 Alarm을 근무자에게 보냄과 동시에 자동 치료하도록 되어 있습니다.\n- 회사는 암호알고리즘을 이용하여 네트워크상의 개인정보를 안전하게 전송할 수 있는 보안장치(SSL 또는 SET)를 채택하고 있습니다.\n- 회사는 해킹 등 회사 정보통신망 침입에 의해 이용자의 개인정보가 유출되는 것을 방지하기 위해 외부로부터의 침입탐지 및 침입차단 시스템을 24시간 가동하고 있습니다.\n\n나. 회사는 이용자의 개인정보보호의 중요성을 인식하고 있으며 이용자의 개인정보보호를 위해 개인정보처리직원을 최소한으로 제한하는 등 다음과 같은 관리적 조치를 취하고 있습니다.\n- 개인정보를 처리하는 직원을 대상으로 새로운 보안 기술 습득 및 개인정보보호의무 등에 관해 정기적인 사내교육 및 외부 위탁교육을 실시하고 있습니다. \n- 회사는 모든 입사자에게 보안서약서를 제출케 함으로 사람에 의한 정보유출을 사전에 방지하고 개인정보처리방침에 대한 이행사항 및 직원의 준수여부를 감시하고 위반내용이 확인되는 경우 이를 시정 또는 개선하고 기타 필요한 조치를 취하기 위한 내부절차를 마련하고 있습니다. 개인정보 관련 처리자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며 입사/퇴사 후 개인정보 사고에 대한 책임을 명확화하고 있습니다. \n- 개인정보와 일반 데이터를 혼합하여 보관하지 않고 별도의 서버를 통해 분리하여 보관하고 있습니다. \n- 전산실 및 자료 보관실 등을 특별 보호구역으로 설정하여 출입을 통제하고 있습니다. \n- 회사는 이용자 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 이용자 개개인이 본인의 개인정보를 보호하기 위해서 자신의 아이디(ID) 와 비밀번호를 적절하게 관리하고 이에 대한 책임을 져야 합니다.\n\n10. 개인정보보호책임자\n' 마이딩고 '는 이용자가 당사의 서비스를 안전하게 이용할 수 있도록 최선을 다하고 있습니다. 이용자는 당사의 서비스 이용과 관련한 모든 민원을 신고하실 수 있으며, 당사는 이용자의 신고사항에 대해 신속하고 성실하게 답변해드리고 있습니다.\n\n개인정보보호책임자 성명 : 이형준\n이메일　: mydingo@naver.com\n전화번호　: 070-4337-4273\n\n기타 개인정보침해에 대한 신고 또는 상담이 필요하신 경우에는 아래 기관으로 문의하시기 바랍니다.\n\n개인정보분쟁조정위원회 전화 : 1833-6972 ( http://www.kopico.go.kr)\n개인정보침해신고센터전화 :(국번없이)118 ( http://privacy.kisa.or.kr)\n대검찰청 첨단범죄수사센터전화 : 02-3480-2000 (http://www.spo.go.kr)\n경찰청 사이버안전국전화 : (국번없이)182 (http://cyberbureau.police.go.kr)\n\n11. 고지의 의무 \n가. 본 개인정보처리방침을 포함한 기타 개인정보보호에 대한 상세한 내용은 서비스 홈페이지 첫 화면에 공개함으로써 이용자가 언제나 용이하게 보실 수 있도록 조치하고 있습니다.\n나. 법령 정책 또는 보안기술의 변경에 따라 중요한 내용의 추가 삭제 및 수정이 있을 시에는 변경되는 개인정보처리방침을 시행하기 전에 서비스 홈페이지를 통해 변경이유 및 내용 등에 대하여 공지하도록 하겠습니다.\n다. 본 개인정보처리방침의 내용은 수시로 변경될 수 있으므로 서비스홈페이지를 방문하실 때 마다 이를 확인하시기 바랍니다. \n\n12. 맟춤제작 상품의 취소,반품,교환\n가. 구매자의 요청에 따라 개별 맞춤 제작되는 상품의 경우 판매자의 의해 취소/반품/교환이 제한될 수 있습니다.\n나. 판매자의 설정에 의해 취소/반품/교환에 관한 제한이 설정되어도 소비자 보호에 관한 법률 제 17조에 위배될 경우, 구매자는 보호받을 수 있습니다.\n다. 취소/반품/교환 제한 사유에 해당되지 않을 경우 일반 상품과 동일하게 취급하여 청약철회가 가능합니다. \n본 방침은 : 2023년 1월 3일부터 시행됩니다.\n`;
    }

    return (
        <div style={{ background: '#F8F8F8' }}>

            <div className='block md:hidden lg:hidden xl:hidden 2xl:hidden'>
                <div
                    className={`w-full px-3 py-3 text-xl text-white font-semibold font-sans inline-block align-middle mb-2`}
                    style={{ background: bgColor }}
                >
                    <div className='inline-block alialign-middle font-sans'>목걸이 자동견적 계산기</div>
                </div>
            </div>
            <div className='hidden md:block lg:block xl:block 2xl:block'>
                <div
                    className={`w-full px-5 py-5 text-2xl text-white font-semibold font-sans inline-block align-middle mb-6`}
                    style={{ background: bgColor }}
                >
                    <div className='inline-block alialign-middle font-sans'>목걸이 자동견적 계산기</div>
                </div>
            </div>
            <div className='block md:hidden lg:hidden xl:hidden 2xl:hidden'>
                <div className='font-sans text-sm font-bold text-gray-950 px-2 pb-2 mt-3'>1. 목걸이 디자인을 선택해 주세요.</div>
            </div>
            <div className='hidden md:block lg:block xl:block 2xl:block'>
                <div className='font-sans text-xl font-semibold text-gray-950 px-5 pb-4'>1. 목걸이 디자인을 선택해 주세요.</div>
            </div>
            <div className='hidden md:block lg:block xl:block 2xl:block'>
                <div className="grid gap-4 px-5 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5">
                    {
                        selectItemInfos.map((item, index) => {

                            return (
                                <button
                                    type="button"
                                    className={`${item.id == selectItemIndex ? `text-white outline-none` : `text-gray-950 ring-0`} rounded shadow-black shadow-sm mx-2 mb-0 text-sm px-3 py-3 font-sans font-semibold break-keep`}
                                    style={{ background: item.id == selectItemIndex ? bgColor : '#FFFFFF' }}
                                    //className="text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
                                    //className="text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
                                    key={`SelectItemView_SelectItemButton_${index}`}
                                    onClick={() => { onSelectItemIndex(item.id) }}
                                    select={item.id == selectItemIndex ? true : false}
                                >
                                    {item.name}
                                </button>
                                // <button
                                //     className="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-600 to-blue-500 group-hover:from-purple-600 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800"
                                //     key={`SelectItemView_SelectItemButton_${index}`}
                                //     onClick={() => { onSelectItemIndex(item.id) }}
                                //     type="button"
                                // >
                                //     <span className="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                                //         {item.name}
                                //     </span>
                                // </button>
                                // <button
                                //     type="button"
                                //     className="focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                                //     key={`SelectItemView_SelectItemButton_${index}`}
                                //     onClick={() => { onSelectItemIndex(item.id) }}
                                // >

                                //     {item.name}
                                // </button>
                                // <SelectItemButton
                                //     select={item.id == selectItemIndex ? true : false}
                                //     onClick={() => { onSelectItemIndex(item.id) }}
                                // >
                                //     <div>{item.name}</div>
                                // </SelectItemButton>
                            )
                        })
                    }
                </div>
            </div>
            <div className='block md:hidden lg:hidden xl:hidden 2xl:hidden pb-2'>
                {
                    selectItemInfosSelectList ?
                        <Select
                            className='h-full rounded-md border-0 bg-transparent py-0 pl-2 pr-1 md:max-[2048px]:pr-7 text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm'
                            isDisabled={selectItemInfosSelectList.length == 0}
                            options={selectItemInfosSelectList}
                            isSearchable={false}
                            placeholder='목걸이를 선택하세요'

                            aria-labelledby="select"
                            onChange={(e) => {
                                onSelectItemIndex(e.value)
                                //onSelectOption('color', e.value)
                            }}
                            maxMenuHeight={'300px'}
                            value={selectItemInfosSelectList.filter((info) => {
                                return info.value == selectItemIndex ? true : false;
                            })}
                        />
                        : null
                }
                {/* <div className="grid gap-4 px-5 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5">
                    {
                        selectItemInfos.map((item, index) => {

                            return (
                                <button
                                    type="button"
                                    className={`${item.id == selectItemIndex?`text-white outline-none`:`text-gray-950 ring-0`} rounded shadow-black shadow-sm mx-2 mb-0 text-sm px-3 py-3 font-sans font-semibold break-keep`}
                                    style={{background:item.id == selectItemIndex?bgColor:'#FFFFFF'}}
                                    //className="text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
                                    //className="text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
                                    key={`SelectItemView_SelectItemButton_${index}`}
                                    onClick={() => { onSelectItemIndex(item.id) }}
                                    select={item.id == selectItemIndex ? true : false}
                                >
                                    {item.name}
                                </button>
                            )
                        })
                    }
                </div> */}
            </div>
            {/* {
                selectItemInfos && selectItemInfos.length > 0 ?
                    <>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            {
                                selectItemInfos.map((item, index) => {
                                    if (index <= 4) {
                                        return null
                                    }

                                    return (
                                        <SelectItemButton
                                            key={`SelectItemView_SelectItemButton_${index}`}
                                            select={item.id == selectItemIndex ? true : false}
                                            onClick={() => { onSelectItemIndex(item.id) }}
                                        >
                                            <div>{item.name}</div>
                                        </SelectItemButton>
                                    )
                                })
                            }
                        </div>
                    </>
                    : null
            } */}
            <div className='block md:hidden lg:hidden xl:hidden 2xl:hidden'>
                <div className='font-sans text-sm font-semibold text-gray-950  pt-2 px-2 mt-4'>2. 세부정보를 선택하시면 선택하신 목걸이+팬던트 디자인 확인이 가능합니다.</div>
                <div className='font-sans text-xs text-gray-500 pb-5 pt-1 px-4 mt-1'>목걸이 사이즈 및 팬던트 크기는 선택하시는 사이즈로 제작되며 아래 이미지는 참고용입니다.</div>
            </div>
            <div className='hidden md:block lg:block xl:block 2xl:block'>
                <div className='font-sans text-xl font-semibold text-gray-950  pt-10 px-5'>2. 세부정보를 선택하시면 선택하신 목걸이+팬던트 디자인 확인이 가능합니다.</div>
                <div className='font-sans text-sm text-gray-500 pb-4 pt-1 px-10'>목걸이 사이즈 및 팬던트 크기는 선택하시는 사이즈로 제작되며 아래 이미지는 참고용입니다.</div>
            </div>
            <>

                {/* <div style={{ display: 'flex', padding: '20px 20px 20px 20px', position:'relative' }}> */}
                <div className={` px-1 md:max-[2048px]:px-7 relative w-full md:max-[2048px]:flex sm:flex-col md:flex-row lg:flex-row xl:flex-row 2xl:flex-row`}>
                    <div
                        //className=' sm:min-[1px]:h-[32rem] sm:min-[1px]:h-[32rem] md:h-[32rem] md:w-[32rem]  lg:h-[32rem] lg:w-[32rem] xl:h-[40rem] xl:w-[40rem] 2xl:max-[2048px]:h-[44rem] 2xl:max-[2048px]:w-[44rem] relative bg-white'
                        className=' md:max-[2048px]:h-[32rem] md:max-[2048px]:w-[25rem] h-[27rem] w-full md:max-[2048px]:pt-0 relative bg-white'
                    >
                        {
                            selectItem ?
                                <div
                                    //className={`p-4 font-semibold text-base text-white 2xl:absolute 2xl:top-0 2xl:left-0 2xl:right-0 xl:absolute xl:top-0 xl:left-0 xl:right-0 lg:absolute lg:top-0 lg:left-0 lg:right-0 sm:absolute sm:top-0 sm:left-0 sm:right-0 md:absolute md:top-0 md:left-0 md:right-0`}
                                    className={`p-4 font-semibold text-base text-white top-0 left-0 right-0`}
                                    style={{ background: '#382B2B' }}
                                >
                                    {selectItem.infotext}
                                </div>
                                // ${viewType=='mydingo'?'bg-blue-300':'bg-red-400'}
                                // <div style={{ position: 'absolute', top:0}}>{selectItem.infotext}</div>
                                :
                                viewType == 'mydingo' ?
                                    <div
                                        className='flex flex-1 justify-center items-center h-full'
                                        style={{ background: bgColor }}
                                    >
                                        <img
                                            className='object-contain bg-gray-300 h-auto w-1/3'
                                            src={`https://mydingo.s3.ap-northeast-2.amazonaws.com/orderimage/mydingo_logo.png`}
                                        >
                                        </img>
                                    </div>
                                    :
                                    <div
                                        className='flex justify-center items-center h-full w-full'
                                    >
                                        <img
                                            className='object-contain bg-gray-300 h-auto w-1/3'
                                            src={`https://mydingo.s3.ap-northeast-2.amazonaws.com/orderimage/patslook_logo.png`}
                                        >
                                        </img>
                                    </div>
                        }
                        {
                            (selectOptionData && selectOptionData.color) ?
                                <div className='flex-1'>
                                    <div className='flex justify-center px-6 sm:px-7 ms:px-7 lg:px-7 xl:px-7 2xl:px-7 pt-5'>
                                        <img
                                            className='object-contain'
                                            src={`https://mydingo.s3.ap-northeast-2.amazonaws.com/orderimage/${selectOptionData.colorImage}`}
                                        >
                                        </img>
                                    </div>
                                </div>
                                :
                                selectItem ?
                                    <div className='flex-1'>
                                        <div className='flex justify-center px-6 sm:px-7 ms:px-7 lg:px-7 xl:px-7 2xl:px-7 pt-5'>
                                            <img
                                                className='object-contain'
                                                src={`https://mydingo.s3.ap-northeast-2.amazonaws.com/orderimage/${selectItem.image}`}
                                            >
                                            </img>
                                        </div>
                                    </div>
                                    // <div className='flex h-full w-full justify-center items-center'>
                                    //     <div className=' font-sans font-semibold text-lg text-red-500'>
                                    //         목걸이 색상을 선택하세요
                                    //     </div>
                                    // </div>
                                    : null
                        }
                        {
                            (selectOptionData && selectOptionData.pendant) ?
                                <div className='flex justify-center'>
                                    <div className='md:max-[2048px]:w-[16rem] w-[12rem]'>
                                        <img className=' object-contain' src={`https://mydingo.s3.ap-northeast-2.amazonaws.com/orderimage/${selectOptionData.pendantImage}`}>
                                        </img>
                                    </div>
                                </div>
                                : null
                        }
                        {/* {
                            (selectOptionData && selectOptionData.color) ?
                            <div className='object-contain flex relative justify-center items-center align-middle'>
                                <div className='flex-1 justify-center items-center align-middle'>
                                </div>
                                
                                {
                                    (selectOptionData && selectOptionData.pendant) ?
                                    <div className='absolute bottom-3 right-3 h-1/4 w-1/4 rounded-full shadow-sm'>
                                        <img className=' object-contain flex-1 rounded-full shadow-sm' src={`https://mydingo.s3.ap-northeast-2.amazonaws.com/orderimage/order_pendant_${selectOptionData.pendant}.png`}>
                                        </img>
                                        
                                    </div>
                                    :null
                                }
                            </div>
                                : null
                        } */}
                    </div>
                    <div className=' flex-1 pl-2 md:pl-7 lg:pl-7 xl:pl-7 2xl:pl-7 pr-3 md:max-[2048px]:pr-7'>
                        <div className=' flex pb-6 pt-8'>
                            <div className=' w-1/3 flex items-center font-sans text-gray-950 font-semibold text-sm'>
                                목걸이 색상
                            </div>
                            <div className='w-2/3 md:max-[2048px]:mr-8'>
                                <Select
                                    className='h-full rounded-md border-0 bg-transparent py-0 pl-2 text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm'
                                    isDisabled={colorOption.length == 0}
                                    options={colorOption}
                                    isSearchable={false}
                                    placeholder={`필수`}

                                    aria-labelledby="select"
                                    onChange={(e) => onSelectOption('color', e.value)}
                                    maxMenuHeight={'300px'}
                                    value={colorOption.filter((option) => {
                                        return option.value === selectOptionData.color;
                                    })}
                                />
                            </div>
                        </div>
                        {
                            !selectItem || pendantOption.length > 0 ?
                                <div className=' flex pb-6'>
                                    <div className=' w-1/3 flex items-center font-sans text-gray-950 font-semibold text-sm'>
                                        팬던트
                                    </div>
                                    <div className='w-2/3 md:max-[2048px]:mr-8'>
                                        <Select
                                            className='h-full rounded-md border-0 bg-transparent py-0 pl-2 text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm'
                                            isDisabled={pendantOption.length == 0 || isSelectColor.length == 0}
                                            options={pendantOption}
                                            isSearchable={false}
                                            //placeholder={`목걸이 펜던트를 선택하세요.`}
                                            placeholder={`필수`}
                                            aria-labelledby="select"
                                            onChange={(e) => onSelectOption('pendant', e.value)}
                                            maxMenuHeight={'300px'}
                                            value={pendantOption.filter((option) => {
                                                return option.value === selectOptionData.pendant;
                                            })}
                                        />
                                    </div>
                                </div>
                                :null
                        }
                        {
                            !selectItem || sizeOption.length > 0 ?
                                <div className=' flex pb-6'>
                                    <div className=' w-1/3 flex items-center font-sans text-gray-950 font-semibold text-sm'>
                                        목걸이 사이즈
                                    </div>
                                    <div className='w-2/3 md:max-[2048px]:mr-8'>
                                        <Select
                                            className='h-full rounded-md border-0 bg-transparent py-0 pl-2 text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm'
                                            isDisabled={sizeOption.length == 0 || isSelectColor.length == 0}
                                            options={sizeOption}
                                            isSearchable={false}
                                            placeholder={`필수`}
                                            aria-labelledby="select"
                                            onChange={(e) => onSelectOption('size', e.value)}
                                            maxMenuHeight={'300px'}
                                            value={sizeOption.filter((option) => {
                                                return option.value === selectOptionData.size;
                                            })}
                                        />
                                    </div>
                                </div>
                                :null
                        }
                        {
                            !selectItem || fontOption.length > 1 ?
                                <div className=' flex pb-6'>
                                    <div className=' w-1/3 flex items-center font-sans text-gray-950 font-semibold text-sm'>
                                        폰트
                                    </div>
                                    <div className='w-2/3 md:max-[2048px]:mr-8'>
                                        <Select
                                            className='h-full rounded-md border-0 bg-transparent py-0 pl-2 text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm'
                                            isDisabled={fontOption.length == 0 || isSelectColor.length == 0}
                                            options={fontOption}
                                            isSearchable={false}
                                            //placeholder={`폰트를 선택하세요.`}
                                            placeholder={`미 선택시 랜덤`}
                                            aria-labelledby="select"
                                            onChange={(e) => onSelectOption('font', e.value)}
                                            maxMenuHeight={'300px'}
                                            value={fontOption.filter((option) => {
                                                return option.value === selectOptionData.font;
                                            })}
                                        />
                                    </div>
                                </div>
                                :null
                        }
                        {
                            !selectItem || imageOption.length > 1 ?
                                <div className=' flex pb-6'>
                                    <div className=' w-1/3 flex items-center font-sans text-gray-950 font-semibold text-sm'>
                                        그림
                                    </div>
                                    <div className='w-2/3 md:max-[2048px]:mr-8'>
                                        <Select
                                            className='h-full rounded-md border-0 bg-transparent py-0 pl-2 text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm'
                                            isDisabled={imageOption.length == 0 || isSelectColor.length == 0}
                                            options={imageOption}
                                            isSearchable={false}
                                            //placeholder={`그림을 선택하세요.`}
                                            placeholder={`미 선택시 그림X`}
                                            aria-labelledby="select"
                                            onChange={(e) => onSelectOption('image', e.value)}
                                            maxMenuHeight={'300px'}
                                            value={imageOption.filter((option) => {
                                                return option.value === selectOptionData.image;
                                            })}
                                        />
                                    </div>
                                </div>
                                :null
                        }
                        {
                            !selectItem || decorationOption.length > 1 ?
                                <div className=' flex pb-6'>
                                    <div className=' w-1/3 flex items-center font-sans text-gray-950 font-semibold text-sm'>
                                        미니장식
                                    </div>
                                    <div className='w-2/3 md:max-[2048px]:mr-8'>
                                        <Select
                                            className='h-full rounded-md border-0 bg-transparent py-0 pl-2 text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm'
                                            isDisabled={decorationOption.length == 0 || isSelectColor.length == 0}
                                            options={decorationOption}
                                            isSearchable={false}
                                            //placeholder={`미니장식을 선택하세요.`}
                                            placeholder={`미 선택시 장식X`}
                                            aria-labelledby="select"
                                            onChange={(e) => onSelectOption('decoration', e.value)}
                                            maxMenuHeight={'300px'}
                                            value={decorationOption.filter((option) => {
                                                return option.value === selectOptionData.decoration;
                                            })}
                                        />
                                    </div>
                                </div>
                                :null
                        }
                        {
                            (selectItem && pendantOption.length == 0 && sizeOption.length == 0 && imageOption.length == 1 && decorationOption.length == 1)?
                            <div className=' h-14'/>
                            :null
                        }
                        <div className=' flex pb-6'>
                            <div className=' w-1/3 flex items-center font-sans text-gray-950 font-semibold text-sm'>
                                수량
                            </div>
                            <div className='w-2/3 flex items-center font-sans font-semibold md:max-[2048px]:mr-8'>
                                <input
                                    className=" bg-white border border-gray-300 text-gray-950 text-sm font-semibold rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-2 mx-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:bg-gray-50"

                                    placeholder=""
                                    type="number"
                                    disabled={isSelectColor.length == 0}
                                    onChange={(e) => {
                                        onSelectOption('count', e.target.value);
                                    }}
                                    value={isSelectColor.length == 0 ? 0 : selectOptionData.count}
                                />EA
                            </div>
                            {/* <div style={{ width: '20%', alignItems: 'flex-end' }}>

                                <div>{inputNumberAutoComma(optionPrice / 100)}</div>개
                            </div> */}
                        </div>
                        <div className=' flex pb-6'>
                            <div className=' w-1/3 flex items-center font-sans text-red-500 font-semibold text-sm'>
                                금액
                            </div>
                            <div className='w-2/3 flex items-center font-sans font-semibold text-red-500 md:max-[2048px]:mr-8'>
                                <div
                                    className=" bg-white border border-gray-300 text-gray-950 text-sm font-semibold rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-2 mx-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                >{inputNumberAutoComma(selectOptionData.totalPrice)}</div>원
                            </div>
                            {/* <div style={{ width: '20%', alignItems: 'flex-end' }}>

                                <div>{inputNumberAutoComma(optionPrice / 100)}</div>개
                            </div> */}
                        </div>
                        {/* <>
                            <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '20px' }}>
                                <div style={{ width: '40%' }}>수량 : </div>
                                
                                <StyledInput
                                    className='h-full rounded-md border-0 bg-transparent py-0 pl-2 pr-7 text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm'
                                    placeholder=""
                                    type="number"
                                    onChange={(e)=>{
                                        onSelectOption('count', e.target.value);
                                    }}
                                    value={selectOptionData.count}
                                />개
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '20px' }}>
                                <div style={{ width: '40%' }}>금액 : </div>
                                <div style={{ width: '40%', alignItems: 'flex-end' }}><div>{inputNumberAutoComma(selectOptionData.totalPrice)}원</div></div>
                            </div>
                        </> */}
                    </div>
                </div>
            </>
            <div className={`flex justify-center items-center pt-10 pb-6`}>
                <button
                    className={`w-48 h-16 rounded font-sans font-semibold text-xl md:max-[2048px]:text-2xl text-white`}
                    isCart={isCart} onClick={onAddCart}
                    style={{ background: bgColor }}
                >
                    상품 담기
                </button>
            </div>
            <div className='block md:hidden lg:hidden xl:hidden 2xl:hidden'>
                <div className='font-sans text-sm font-semibold text-gray-950  pb-4 pt-2 px-2'>3. 주문하실 견적서를 확인한 뒤 판매자에게 전송해주세요.</div>
            </div>
            <div className='hidden md:block lg:block xl:block 2xl:block'>
                <div className='font-sans text-xl font-semibold text-gray-950 pb-4 pt-10 px-5'>3. 주문하실 견적서를 확인한 뒤 판매자에게 전송해주세요.</div>
            </div>
            <div className=' px-6 hidden md:flex md:flex-col'>
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 font-sans">
                    <thead className='text-sm text-gray-900 uppercase bg-gray-300 dark:bg-gray-700 dark:text-gray-400 font-sans'>
                        <tr className='sm:table-row'>
                            <th scope="col" className="px-6 py-3">선택</th>
                            <th scope="col" className="px-6 py-3">수량</th>
                            <th scope="col" className="px-6 py-3">목걸이 이름</th>
                            <th scope="col" className="px-6 py-3">선택된 옵션</th>
                            <th scope="col" className="px-6 py-3">금액</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            cartList && cartList.length > 0 ?
                                cartList.map((cartitem, cartindex) => {
                                    return (

                                        <tr className="border-b bg-white sm:table-row'>">
                                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                <input
                                                    type="checkbox"
                                                    checked={cartSelectList.filter((_select) => { return _select == cartindex; }).length > 0}
                                                    onChange={({ target: { checked } }) => onAddCartSelectList(cartindex)}
                                                />
                                            </th>
                                            <th className="px-6 py-4">{inputNumberAutoComma(cartitem.count)}개</th>
                                            <th className="px-6 py-4">{cartitem.name}</th>
                                            <th className="px-6 py-4">{cartitem.optionText}</th>
                                            <th className="px-6 py-4">{inputNumberAutoComma(cartitem.totalPrice)}원</th>
                                        </tr>

                                    )
                                }) : null
                        }
                    </tbody>

                </table>
                {
                    cartList.length < 5 ?
                        <div className=' bg-white w-full' style={{ height: `${(5 - cartList.length) * 50}px` }} />
                        : null
                }
            </div>
            <div className=' px-6 md:max-[2048px]:hidden w-full'>
                {
                    cartList && cartList.length > 0 ?
                        cartList.map((cartitem, cartindex) => {
                            return (
                                <div
                                    key={`cartList_${cartindex}`}
                                    className='bg-white rounded text-sm font-sans px-4 py-4 border-2'
                                >
                                    <input
                                        type="checkbox"
                                        checked={cartSelectList.filter((_select) => { return _select == cartindex; }).length > 0}
                                        onChange={({ target: { checked } }) => onAddCartSelectList(cartindex)}
                                    />
                                    <div className="px-6 py-4">{inputNumberAutoComma(cartitem.count)}개</div>
                                    <div className="px-6 py-4">{cartitem.name}</div>
                                    <div className="px-6 py-4">{cartitem.optionText}</div>
                                    <div className="px-6 py-4">{inputNumberAutoComma(cartitem.totalPrice)}원</div>
                                </div>
                            )
                        }) : null
                }
            </div>
            {/* <div style={{ width: '100%', display: 'flex', height: '30px', alignItems: 'center' }}>
                <div style={{ width: '10%', height: '100%', border: `1px solid ${palette.webGray[17]}`, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>선택</div>
                <div style={{ width: '10%', height: '100%', border: `1px solid ${palette.webGray[17]}`, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>수량</div>
                <div style={{ width: '20%', height: '100%', border: `1px solid ${palette.webGray[17]}`, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>목걸이 이름</div>
                <div style={{ width: '40%', height: '100%', border: `1px solid ${palette.webGray[17]}`, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>선택된 옵션</div>
                <div style={{ width: '20%', height: '100%', border: `1px solid ${palette.webGray[17]}`, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>금액</div>
            </div>
            {
                cartList && cartList.length > 0 ?
                    <div style={{ width: '100%', alignItems: 'center' }}>
                        {
                            cartList.map((cartitem, cartindex) => {
                                return (
                                    <div
                                        style={{ width: '100%', display: 'flex', height: '100%', alignItems: 'center' }}
                                        key={`SelectItemView_cartList_${cartindex}`}
                                    >
                                        <div style={{ width: '10%', height: '100%', border: `1px solid ${palette.webGray[17]}`, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>

                                            <input
                                                type="checkbox"
                                                checked={cartSelectList.filter((_select) => { return _select == cartindex; }).length > 0}
                                                onChange={({ target: { checked } }) => onAddCartSelectList(cartindex)}
                                            />
                                        </div>
                                        <div style={{ width: '10%', height: '100%', border: `1px solid ${palette.webGray[17]}`, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>{inputNumberAutoComma(cartitem.count)}개</div>
                                        <div style={{ width: '20%', height: '100%', border: `1px solid ${palette.webGray[17]}`, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>{cartitem.name}</div>
                                        <div style={{ width: '40%', height: '100%', border: `1px solid ${palette.webGray[17]}`, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>{cartitem.optionText}</div>
                                        <div style={{ width: '20%', height: '100%', border: `1px solid ${palette.webGray[17]}`, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>{inputNumberAutoComma(cartitem.totalPrice)}원</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    : null
            } */}
            <div className='px-5'>
                <div className='text-sm text-gray-900 bg-gray-300 dark:bg-gray-700 dark:text-gray-400 font-sans w-full px-5 py-4 flex justify-end'>
                    <div
                        className=' bg-white rounded w-24 h-8 flex justify-center items-center font-sans text-gray-800 text-sm cursor-pointer'
                        onClick={onDeleteCart}
                    >
                        선택삭제
                    </div>
                    <div
                        className=' bg-white rounded w-24 h-8 flex justify-center items-center font-sans text-gray-800 text-sm cursor-pointer ml-8'
                        onClick={onClearCart}
                    >
                        전체삭제
                    </div>
                </div>
            </div>
            <div className='mx-5 my-8 bg-white'>
                <div className='px-3 py-4 md:max-[2048px]:px-8 md:max-[2048px]:py-8 border-2 border-gray-300'>
                    <div className='flex flex-col md:max-[2048px]:flex-row'>
                        <div className='w-full md:max-[2048px]:w-4/6'>

                            <div className=' pb-3 font-sans font-bold text-xl text-gray-950'>총 결제금액</div>
                            <div className=' pb-3 font-sans font-semibold text-sm text-gray-600'>상품수량을 결제수량대로 구매해주시면 됩니다.</div>
                            <div style={{ padding: '10px 10px 10px 10px', fontWeight: 400, fontSize: '1rem' }}></div>
                        </div>
                        <div className='w-full md:max-[2048px]:w-2/6'>
                            <div className='flex w-full justify-center'>
                                <div className='w-2/3'>

                                    <div className=' font-sans font-semibold text-sm text-gray-950'>목걸이 견적금액</div>
                                </div>
                                <div className='w-2/3 flex mr-4'>
                                    <div className=' flex-1' />
                                    <div className=' font-sans text-sm font-semibold text-gray-950'>{inputNumberAutoComma(totalPrice)}원</div>
                                </div>
                            </div>
                            <div className='flex w-full justify-center pt-7'>
                                <div className='w-2/3'>

                                    <div className=' font-sans font-semibold text-sm text-gray-950'>배송비</div>
                                </div>
                                <div className='w-2/3 flex mr-4'>
                                    <div className=' flex-1' />
                                    <div className=' font-sans text-sm font-semibold text-gray-950'>무료이벤트</div>
                                </div>
                            </div>
                            <div className='flex w-full justify-center pt-7'>
                                <div className='w-2/3'>

                                    <div className=' font-sans font-semibold text-sm text-gray-950'>총 결제 금액</div>
                                </div>
                                <div className='w-2/3 flex mr-4'>
                                    <div className=' flex-1' />
                                    <div className=' font-sans text-sm font-semibold text-gray-950'>{inputNumberAutoComma(totalPrice)}원</div>
                                </div>
                            </div>
                            <div className='flex w-full justify-center pt-7'>
                                <div className='w-2/3'>

                                    <div className=' font-sans font-semibold text-xl text-red-500'>결제수량</div>
                                </div>
                                <div className='w-2/3 flex mr-4'>
                                    <div className=' flex-1' />
                                    <div className=' font-sans text-xl font-semibold text-red-500'>{inputNumberAutoComma(totalPrice / 100)}개</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className=' px-2 py-3 md:max-[2048px]:px-8 md:max-[2048px]:py-8'>
                    <div className=' font-sans text-sm text-red-500 font-semibold'>
                        주문시 수취인 성함과 동일하게 작성해주셔야 확인이 가능합니다.
                    </div>
                    <div className='flex w-full md:max-[2048px]:w-1/3  items-center font-sans font-semibold mt-4'>
                        <input
                            className="font-sans bg-white border text-gray-950 text-sm font-semibold rounded block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:bg-gray-50"
                            style={{ borderColor: bgColor }}
                            placeholder="수취인명"
                            type='text'
                            autoComplete="off"
                            onChange={onChangeUserName}
                            value={userName}
                        />
                    </div>
                    <div className='flex w-full md:max-[2048px]:w-1/3  items-center font-sans font-semibold mt-4'>
                        <input
                            className="font-sans bg-white border text-gray-950 text-sm font-semibold rounded block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:bg-gray-50"
                            style={{ borderColor: bgColor }}
                            placeholder="수취인 연락처"
                            type='text'
                            autoComplete="off"
                            onChange={onChangeUserPhone}
                            value={userPhone}
                        />
                    </div>
                    <div className='w-full flex flex-col md:max-[2048px]:flex-row font-sans font-semibold mt-4'>
                        <div className='w-full md:max-[2048px]:w-1/3 flex items-center font-sans font-semibold'>
                            <input
                                className="font-sans bg-white border text-gray-950 text-sm font-semibold rounded block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:bg-gray-50"
                                style={{ borderColor: bgColor }}
                                placeholder="수취인 이메일"
                                type='text'
                                autoComplete="off"
                                onChange={onChangeUserEmail}
                                value={userEmail}
                            />
                        </div>
                        <div className='w-full mt-4 md:max-[2048px]:w-2/5 md:max-[2048px]:mt-0 md:max-[2048px]:ml-8 font-sans text-gray-600 text-xs font-semibold'>수취인 이메일로 견적내용과 제작정보가 전송됩니다. 고객님께서 확인 가능한 이메일 주소를 기재해주세요</div>
                    </div>
                    <div className=' mt-9 font-sans font-medium md:max-[2048px]:text-xl text-base text-gray-950'>
                        펜던트 각인 내용을 기재해주세요
                    </div>
                    <div className='w-full flex items-center font-sans font-semibold mt-3'>
                        <input
                            className="font-sans bg-white border text-gray-950 text-sm font-semibold rounded block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:bg-gray-50"
                            style={{ borderColor: bgColor }}
                            type='text'
                            placeholder="여러 아이의 정보를 기재 하실때는 '/'로 구분해주세요"
                            autoComplete="off"
                            onChange={onChangeFrontText}
                            value={frontText}
                        />
                    </div>
                    <div className=' ml-3 mt-2 mb-10 flex md:max-[2048px]:text-sm text-xs text-gray-950 font-sans font-semibold'>
                        <div>{'Ex) '}</div>
                        <div className=' md:max-[2048px]:ml-3 ml-1'>
                            <div>{'1.앞면:호빵이, 2.뒷면:010.1234.5678'}</div>
                            <div>{'1.앞면:호빵이, 2.뒷면:010.1234.5678  /  1.앞면:미미, 2.뒷면:010.1234.5678'}</div>
                        </div>
                    </div>
                    {/* <div className='w-full flex items-center font-sans font-semibold mt-3'>
                        <input
                            className="font-sans bg-white border text-gray-950 text-sm font-semibold rounded block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:bg-gray-50"
                            style={{borderColor:bgColor}}
                            type='text'
                            placeholder="뒷면 각인 내용"
                            autoComplete="off"
                            onChange={onChangeBackText}
                            value={backText}
                        />
                    </div> */}
                </div>
            </div>
            {/* <div style={{ border: `1px solid #6d6`, padding: '50px 50px 50px 50px' }}>
                <div style={{ display: 'flex' }}>
                    <div style={{ flex: 1 }}>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <div style={{ display: 'flex', width: '100%', paddingBottom: '20px' }}>
                            <div style={{ flex: 1 }} />
                            <div style={{ width: '30%' }}>목걸이 견적금액</div>
                            <div style={{ width: '20%' }}>{inputNumberAutoComma(totalPrice)}원</div>
                        </div>
                        <div style={{ display: 'flex', width: '100%', fontSize: '1.2rem', paddingBottom: '40px' }}>
                            <div style={{ flex: 1 }} />
                            <div style={{ width: '30%' }}>총 결제 금액</div>
                            <div style={{ width: '20%' }}>{inputNumberAutoComma(totalPrice)}원</div>
                        </div>
                        <div style={{ display: 'flex', width: '100%', fontSize: '1.5rem', color: '#f00', fontWeight: 600 }}>
                            <div style={{ flex: 1 }} />
                            <div style={{ width: '30%' }}>결제수량</div>
                            <div style={{ width: '20%' }}>{inputNumberAutoComma(totalPrice / 100)}개</div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* <div style={{ padding: '20px 20px 20px 20px', flexDirection: 'column', display: 'flex' }}>
                <div style={{ color: '#f00', fontSize: '1rem', fontWeight: 600 }}> ★ 주문시 수취인 성함과 동일하게 작성해주셔야 확인이 가능합니다.</div>
                <SubInfoInput
                    placeholder="수취인명"
                    autoComplete="off"
                    onChange={onChangeUserName}
                    value={userName}
                >

                </SubInfoInput>
                <SubInfoInput
                    placeholder="수취인 연락처"
                    autoComplete="off"
                    onChange={onChangeUserPhone}
                    value={userPhone}
                >

                </SubInfoInput>
                <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                    <SubInfoInput
                        placeholder="수취인 이메일"
                        autoComplete="off"
                        onChange={onChangeUserEmail}
                        value={userEmail}
                    >

                    </SubInfoInput>
                    <div>
                        <div style={{ paddingTop: 5, paddingLeft: 30 }}>{'수취인 이메일로 견적 내용과 제작정보가 전송됩니다.'}</div>
                        <div style={{ paddingTop: 5, paddingLeft: 30 }}>{'고객님께서 확인 가능한 이메일 주소를 기재해주세요.'}</div>
                    </div>
                </div>

                <div style={{ color: '#000', fontSize: '1.2rem', paddingTop: 30, paddingBottom: 10 }}>팬던트 각인내용</div>
                <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                    <div style={{ paddingTop: 5, paddingRight: 10 }}>팬던트 앞면 각인 내용 : </div>
                    <SubTextInfoInput
                        placeholder="앞면 각인 내용을 입력하세요."
                        autoComplete="off"
                        onChange={onChangeFrontText}
                        value={frontText}
                    />
                </div>
                <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                    <div style={{ paddingTop: 5, paddingRight: 10 }}>팬던트 뒷면 각인 내용 : </div>
                    <SubTextInfoInput
                        placeholder="뒷면 각인 내용을 입력하세요."
                        autoComplete="off"
                        onChange={onChangeBackText}
                        value={backText}
                    />
                </div>

                <div style={{ color: '#f00', fontSize: '1.2rem', fontWeight: 600, paddingTop: 40 }}>※ 반드시 확인 후 결제를 진행해주세요!</div>
                <div style={{ color: '#f00', fontSize: '1rem', fontWeight: 600, paddingTop: 10 }}>판매자에게 견적서를 전송해주신 뒤 결제 수량대로 진행해 주시면 됩니다.</div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                    <input
                        type="checkbox"
                        checked={termsCheck}
                        onChange={({ target: { checked } }) => onChangeTermsCheck(checked)}
                    />
                    <div style={{ paddingLeft: 10, paddingRight: 20 }}>개인정보 취급방침 및 마케팅메시지의 수신을 동의합니다.</div>
                    <TermsButton
                        onClick={() => setTermsView(!termsView)}
                    >
                        <div>전문보기</div>
                    </TermsButton>
                </div>
                {
                    termsView ?
                        <textarea
                            style={{ height: 100 }}
                            value={`DIY전문쇼핑몰 페인트인포는 고객님들의 개인정보를 매우 소중하게 생각하며 다음과 같은 개인정보취급방침을 시행하고 있습니다.\n이 개인정보취금방침은 관련 법률 또는 지침의 변경, 회사정책의 변화에 따라 달라질 수 있으니, 고객님께서는 DIY전문 쇼핑몰 페인트인포 방문시 수시로 확인하여 주시기 바랍니다. \n\n'페인트인포'는 (이하 '회사')는 고객님의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법류을 준수하고 있습니다. \n회사는 개인정보취급방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.\n회사는 개인정보 취급방침을 개정하는 경우 웹사이트 공지사항 (또는 개별공지)를 통하여 공지할 것입니다.\n본 방침은 2009년 05월 01일부터 시행됩니다. \n\n\n\n1. 수집하는 개인정보의 항목 및 방법\n\n회사는 회원가입, 상담, 서비스 신청 등등을 위해 아래와 같은 개인정보를 수집하고 있습니다.\n\n* 수집항목 : 이름, 성별, 로그인ID, 비밀번호, 자택 전화번호, 자택주소, 휴대전화번호, 이메일, 직업, 신용카드정보, 은행계좌 정보, 서비스 이용기록, 접속 로그, 쿠키, 접속 IP정보, 결제기록, 관심상품, 접속경로\n* 개인정보 수집방법 : 홈페이지 (회원가입, 물품구매)\n\n\n\n2. 개인정보의 수집 및 이용목적\n\n회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.\n\n* 서비스 제공에 과한 계약 이행 및 서비스 제공에 따른 요금정산 - 콘텐츠 제공, 구매 및 요금 결제, 물품배송 또는 청구지 등 발송, 금융거래 본인 인증 및 금융 서비스, 요금 추심\n* 회원관리- 회원제 서비스 이용에 따른 본인확인, 개인식별, 불량회원의 부정 이용 방지와 비인가 사용방지, 불만처리 등 민원처리, 고지사항 전달\n* 마케팅 및 광고에 활용- 이벤트 등 광고성 정보전달\n\n\n\n3. 개인정보의 보유 및 이용기간\n\n원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다.\n단, 관계법령의 규정에 희아혀 보존 할 필요가 있는 경우, 회사는 아래와 같이 관계법령에서 정한 일정한 기간동안 회원정보를 보관합니다.\n\n* 보존항목 : 이름, 성별, 로그인ID, 자택 전화번호, 휴대전화번호, 신용카드정보, 은행계좌 정보\n* 보존근거 : 전자상거래등에서의 소비자보호에 관한 법률, 신용정보의 이용 및 보호에 관한 법률\n* 보존기간 : 3개월\n\n\n\n4. 개인정보의 파기 절차 및 방법\n\n회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.\n\n* 파기절차 : 회원밍 ㅣ회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져 (종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라 (보유 및 이용기간 참조) 일정기간 저장된 후 파기되어 집니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.\n* 파기방법 : 전자적 파일형태로 저장되 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제됩니다.\n\n\n\n5. 개인정보 제공동의\n\n회사는 회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.\n\n- 이용자들이 사전에 동의한 경우\n- 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우\n\n\n\n6. 수집한 개인정보의 취급위탁\n\n회사는 고객님의 동의없이 고객님의 정보를 외부 업체에 위탁하지 않습니다. \n향후 그러한 필요가 생길 경우, 위탁 대상자와 위탁 업무 내용에 대해 고객님에게 통지하고 필요한 경우 사전 동의를 받도록 하겠습니다.\n\n* 수탁자 : NICE평가정(주) - 수탁범위 : 실명/본인인증, 아이핀 제공 \n* 수탁자 : KCP, LG U+ - 수탁범위 : 상품구매에 필요한 신용카드, 현금결제등의 결제정보 전송 \n* 수탁자 : CJ대한통운택배, 경동택배 - 수탁범위 : 상품의 배송업무 처리\n\n\n\n7. 이용자 및 법정대리인의 권리와 그 행사방법\n\n이용자 및 법정 대리인은 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며 가입해지를 요청할 수 있습니다. 이용자 혹은 만 14세 미만 아동의 개인정보 조회 및 수정을 위해서는 '개인정보변경' (또는 '회원정보수정' 등)을 가입해지(동의철회)를 위해서는 "회원탈퇴"를 클릭하여 본인절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체없이 조치하겠습니다. 귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제 3자에게 지체없이 통보하여 정정이 이루어지도록 하겠습니다. 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 수닙하는 개인정보의 보유 및 이용기간에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용 할 수 없도록 처리하고 있습니다.\n\n\n\n8. 개인정보수집장치의 설치,운영,거부에 관한 사항\n\n회사는 귀하의 정보를 수시로 저장하고 찾아내는 '쿠키(Cookie)'등을 운영합니다. 쿠키란 "회사"의 웹사이트를 운용하는데 이용되는 서버가 \n귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다. 회사는 다음과 같은 목적을 위해 쿠키를 사용합니다.\n단, 귀하께서 쿠키 설치를 거부하였을 경우, 서비스 제공에 어려움이 있을 수 있습니다.\n\n* 쿠키 등 사용목적 \n- 회원과 비회원의 접속 빈도나 방문 시간등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정보 및 방문 횟수 파악등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공 \n- 귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 귀하는 웹브라우저에서 옵션을 설정하여 모든 쿠키를 허용하거나, 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수 있습니다. \n* 설정방법 : - (예: 인터넷 익스플로어의 경우 웹브라우저 상단의 도구 메뉴 > 인터넷 옵션 > 개인정보 클릭)\n\n\n\n9. 개인정보에 관한 민원서비스\n\n회사는 고객의 개인정보와 관련한 불만을 처리하기 위하여 아래와 같은 관련 부서 및 개인정보 관리책임자를 지정하고 있습니다.\n\n* 고객서비스 담당부서 : 고객관리팀 \n* 담당자 : 유효근 \n* 전화번호 : 1688-8552\n* 이메일 : paintinfo@hanmail.net\n\n\n귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 또는 담당부서로 신고하실 수 있습니다. \n회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴것입니다. 기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.\n\n1. 개인분쟁조정위원회 (www.1336.or.kr/1336) \n2. 정보보호마크인증위원회 (www.erprivacy.or.kr/02-580-0533~4) \n3. 대검찰청 인터넷범죄수사센터 (http://icic.soop.go.kr/02-3480-3360)\n4. 경찰청 사이버테러대응센터 (www.ctrc.go.kr/02-392-0330)\n\n\n\n10. 기타 개인정보 취급에 관한 방침\n\n2006년 09월 25일부터 적용되는 개정 주민등록법에 의하면 타인의 주민등록번호를 도용하여 온라인 회원가입을 하는 등 타인의 주민등록번호를 부정사용하는 자는 3년 이하의 징역 또는 1천만원 이하의 벌금형에 처해질 수 있습니다. 따라서 타인의 주민등록번호를 도용하여 회원가입을 사히려는 분들 또는 회원으로 가입하신 분들은 즉시 도용행위를 중단해 주실 것을 부탁드립니다.`}
                        />
                        : null
                }
            </div> */}
            <div className='flex justify-center mt-11 font-sans text-sm text-red-500 mb-6 mx-3'>
                판매자에게 견적서를 전송해주신 뒤 결제수량대로 결제를 진행해주시면 됩니다.
            </div>
            <div className='flex items-center justify-center mx-3'>
                <input
                    className=' w-7 h-7 md:max-[2048px]:w-6 md:max-[2048px]:h-6'
                    type="checkbox"
                    checked={termsCheck}
                    onChange={({ target: { checked } }) => onChangeTermsCheck(checked)}
                />
                <div className=' px-2 font-sans md:max-[2048px]:text-sm text-xs'>개인정보 취급방침 및 마케팅메시지의 수신을 동의합니다.</div>
                <div
                    className='flex items-center justify-center rounded bg-gray-300 font-sans text-sm text-gray-950 w-24 h-8 cursor-pointer'
                    onClick={() => setTermsView(!termsView)}
                >
                    전문보기
                </div>
            </div>
            {
                termsView ?
                    <textarea
                        className='w-4/5 h-28 my-10 mx-10 p-5'
                        value={terminfo}
                    />
                    : null
            }


            <div className='flex justify-center items-center mb-16 mt-10'>
                <div
                    className='rounded w-11/12 h-20 flex justify-center items-center cursor-pointer font-sans font-semibold md:max-[2048px]:text-2xl text-xl text-white'
                    style={{ background: bgColor }}
                    onClick={onCommit}
                >
                    판매자에게 전송하기
                </div>
            </div>
            <div className=' h-10'></div>

            {/* <CommitButton onClick={onCommit}>
                        <div>판매자에게 전송하기</div>
                    </CommitButton>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

<TermsButton
    onClick={() => setTermsView(!termsView)}
>
    <div>전문보기</div>
</TermsButton>
</div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CommitButton onClick={onCommit}>
                    <div>판매자에게 전송하기</div>
                </CommitButton>
            </div> */}
        </div>
    );
};

export default SelectItemView;

